import { TarefaTipo, TarefaStatus, TarefaVisibilidade, MensagemTipoAutor, TarefaLogEvento, } from '../generated/backend-enums.js';
export { TarefaTipo, TarefaStatus, TarefaVisibilidade, MensagemTipoAutor, TarefaLogEvento };
export const TarefaTipoMap = {
    [TarefaTipo.SOLICITAR_AP]: 'Solicitar geração de AP',
    [TarefaTipo.SOLICITAR_AJUSTE_AP]: 'Questionar AP',
    [TarefaTipo.COBRAR_APROVACAO_AP]: 'Cobrar aprovação de AP',
    [TarefaTipo.QUESTIONAR_VERSAO]: 'Questionar versão',
    [TarefaTipo.QUESTIONAR_JOB]: 'Questionar job',
    [TarefaTipo.QUESTIONAR_BRIEFING]: 'Questionar briefing',
    [TarefaTipo.QUESTIONAR_PAPER]: 'Questionar paper',
    [TarefaTipo.SOLICITAR_AJUSTE_PLANILHA_ATENDIMENTO]: 'Questionar planilha de atendimento',
    [TarefaTipo.SOLICITAR_ORCAMENTO_PRE_PRODUCAO]: 'Solicitar orçamento de pré-produção',
    [TarefaTipo.QUESTIONAR_ARQUIVO_APROVACAO]: 'Questionar arquivo de aprovação',
    [TarefaTipo.CORRIGIR_FATURAMENTO]: 'Corrigir faturamento reprovado',
    [TarefaTipo.SOLICITAR_DESFATURAMENTO]: 'Solicitar desfaturamento',
    [TarefaTipo.AP_VALOR_ABAIXO_SALDO_UTILIZADO]: 'AP com valor abaixo do já faturado',
    [TarefaTipo.CRIAR_CLIENTE]: 'Criar cliente',
    [TarefaTipo.SOLICITAR_CRIACAO_CLIENTE]: 'Pedido de cadastro de cliente',
    [TarefaTipo.GENERICA]: 'Tarefa do job',
    [TarefaTipo.CRIAR_BRIEFING]: 'Criar briefing',
    [TarefaTipo.CRIAR_PAPER]: 'Criar paper',
    [TarefaTipo.CRIAR_ESTUDO_VERBA]: 'Criar estudo de verba',
    [TarefaTipo.PEDIDO_BRINDE]: 'Pedido de gift',
};
export const TarefaVisibilidadeMap = {
    [TarefaVisibilidade.PUBLICA]: 'Pública',
    [TarefaVisibilidade.PRIVADA]: 'Privada',
};
export const TarefaStatusMap = {
    [TarefaStatus.PENDENTE]: 'Pendente',
    [TarefaStatus.EM_EXECUCAO]: 'Em Execução',
    [TarefaStatus.CONCLUIDO]: 'Concluído',
    [TarefaStatus.CANCELADO]: 'Cancelado',
    [TarefaStatus.ARQUIVADO]: 'Arquivado',
};
export const MensagemTipoAutorMap = {
    [MensagemTipoAutor.CRIADOR]: 'Criador',
    [MensagemTipoAutor.ATRIBUIDO]: 'Atribuído',
    [MensagemTipoAutor.OBSERVADOR]: 'Observador',
    [MensagemTipoAutor.ADMIN]: 'Admin',
    [MensagemTipoAutor.SISTEMA]: 'Sistema',
};
export const TarefaLogEventoMap = {
    [TarefaLogEvento.CRIADA]: 'Criada',
    [TarefaLogEvento.INICIADA]: 'Em execução',
    [TarefaLogEvento.CONCLUIDA]: 'Concluída',
    [TarefaLogEvento.CANCELADA]: 'Cancelada',
    [TarefaLogEvento.ARQUIVADA]: 'Arquivada',
    [TarefaLogEvento.REABERTA]: 'Reaberta',
    [TarefaLogEvento.REATRIBUIDA]: 'Reatribuída',
    [TarefaLogEvento.PRAZO_ALTERADO]: 'Prazo alterado',
    [TarefaLogEvento.ANEXO_ADICIONADO]: 'Anexo adicionado',
    [TarefaLogEvento.ANEXO_REMOVIDO]: 'Anexo removido',
    [TarefaLogEvento.OBSERVADOR_ADICIONADO]: 'Observador adicionado',
    [TarefaLogEvento.OBSERVADOR_REMOVIDO]: 'Observador removido',
    [TarefaLogEvento.MENSAGEM_ADICIONADA]: 'Comentário',
};
